import React from 'react'

import PinkThumb from './images/pink-thumb.png'
import BlueThumb from './images/blue-thumb.png'
import YellowThumb from './images/yellow-thumb.png'
import GreenThumb from './images/green-thumb.png'

export const generateRandomThumb = () => {
    const thumbs = [PinkThumb, BlueThumb, YellowThumb, GreenThumb]
    return thumbs[Math.floor(Math.random() * thumbs.length)]
}

export const generateDefaultThumb = () => {
    return BlueThumb
}

export const RandomGThumbnail = () => {
    return <img src={generateRandomThumb()} alt="g-thumb" />
}
